import styled, { css } from 'styled-components';
export const Container = styled.div `
  display: ${({ $display }) => $display};
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-brand);
  font-family: var(--font-family-body);
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--font-letter-spacing-normal);
  white-space: nowrap;
  cursor: default;

  ${({ $size }) => $size === 'small' &&
    css `
      padding: var(--space-100) var(--space-200);
      font-size: var(--font-size-200);
      line-height: var(--font-line-height-200);
      height: var(--space-600);
    `}

  ${({ $size }) => $size === 'medium' &&
    css `
      padding: var(--space-150) var(--space-250);
      font-size: var(--font-size-300);
      line-height: var(--font-line-height-300);
      height: var(--space-800);
    `}

  ${({ $size }) => $size === 'large' &&
    css `
      padding: var(--space-200) var(--space-350);
      font-size: var(--font-size-400);
      line-height: var(--font-line-height-400);
      height: var(--space-1000);
    `}

  ${({ $appearance }) => $appearance === 'default' &&
    css `
      color: var(--text-secondary);
      border: 1px solid var(--border-primary);
      background: var(--bg-transparent);
    `}

  ${({ $appearance }) => $appearance === 'success' &&
    css `
      color: var(--text-success-secondary);
      border: 1px solid var(--border-success);
      background: var(--bg-success-secondary);
    `}

  ${({ $appearance }) => $appearance === 'alert' &&
    css `
      color: var(--text-alert-secondary);
      border: 1px solid var(--border-alert);
      background: var(--bg-alert-secondary);
    `}

  ${({ $appearance }) => $appearance === 'critical' &&
    css `
      color: var(--text-critical-secondary);
      border: 1px solid var(--border-critical);
      background: var(--bg-critical-secondary);
    `}

  ${({ $appearance }) => $appearance === 'strong' &&
    css `
      color: var(--text-primary-invert);
      background: var(--bg-primary-invert);
    `}

  ${({ $hoverable, $appearance }) => $hoverable &&
    css `
      cursor: pointer;

      &:hover {
        ${$appearance === 'default' &&
        css `
          border: 1px solid var(--border-primary-hover);
          background: var(--bg-transparent-strong);
        `}

        ${$appearance === 'success' &&
        css `
          border: 1px solid var(--border-success-hover);
          background: var(--bg-success-secondary-hover);
        `}

        ${$appearance === 'alert' &&
        css `
          border: 1px solid var(--border-alert-hover);
          background: var(--bg-alert-secondary-hover);
        `}

        ${$appearance === 'critical' &&
        css `
          border: 1px solid var(--border-critical-hover);
          background: var(--bg-critical-secondary-hover);
        `}
      }
    `}

  & > * + * {
    margin-left: var(--space-150);
  }
`;
